import Slide from "./components/Slide/Slide";
import styles from "./TextImageSlideshow.module.scss";
import TextImageSlideshowProps from "./TextImageSlideshowProps.interface";
import useHover from "./hooks/useHover";
import useInterval from "./hooks/useInterval";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import IconViewer from "components/IconViewer/IconViewer";
import React, { FunctionComponent, useRef, useState } from "react";
import useAnchor from "blocks/hooks/useAnchor";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const TextImageSlideshow: FunctionComponent<TextImageSlideshowProps> = (props) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    const delay = props.settings.slidesDelay ? props.settings.slidesDelay * 1000 : 3000;

    const wrapperStylesElementRef = useRef<any>(null);
    const isHover = useHover(wrapperStylesElementRef);

    useInterval(() => {
        handleClickRight();
    }, !isHover ? delay : null);

    const handleClickLeft = () => {
        if (currentSlide === 0 && props.content.slides) {
            setCurrentSlide(props.content.slides.length - 1);
        }
        else {
            setCurrentSlide(currentSlide - 1);
        }
    };

    const handleClickRight = () => {
        if (props.content.slides && currentSlide === props.content.slides.length - 1) {
            setCurrentSlide(0);
        }
        else {
            setCurrentSlide(currentSlide + 1);
        }
    };

    const handlePaginationClick = (index: number) => {
        setCurrentSlide(index);
    };

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses, ...splitClasses)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            {/* Pagination */}
            <div className={styles.pagination}>
                {props.content.slides && props.content.slides.map((_, index) => {
                    const currentImageClass = currentSlide === index ? styles.is_active : styles.is_inactive;
                    return (
                        <button key={index} className={styles.pagination_item}>
                            <span className={combineClasses(styles.pagination_dot, currentImageClass)} onClick={() => handlePaginationClick(index)}></span>
                        </button>
                    );
                })}
            </div>

            {/* Controls */}
            <div className={styles.controls}>
                <button className={styles.control_button} onClick={() => handleClickLeft()}>
                    <IconViewer className={styles.control_icon} name="chevron-circle-left" />
                </button>
                <button className={styles.control_button} onClick={() => handleClickRight()}>
                    <IconViewer className={styles.control_icon} name="chevron-circle-right" />
                </button>
            </div>

            {/* Slides */}
            <div className={styles.slides_wrapper}>
                {props.content.slides && props.content.slides.length > 0 ? props.content.slides.map((slide, index) => {
                    return <Slide key={slide.contentUdi} {...slide} topSettings={props.settings} currentSlide={currentSlide} index={index} />;
                })
                    : null}
            </div>
        </section>
    );
};

export default TextImageSlideshow;
